export default "__VITE_ASSET__BKkJkCWW__"